import { motion } from 'framer-motion';
import { FadeUp } from './MaskReveal';
import { SERVICES, SERVICES_CLOSING } from '../../lib/site-data';

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative bg-ink-900 py-16 md:py-24">
      <div className="container-editorial">
        <div className="mb-10 md:mb-14 max-w-4xl">
          <FadeUp>
            <span className="eyebrow">03 — Our Services</span>
          </FadeUp>
          <FadeUp delay={0.1}>
            <h2 className="display-heading mt-6 text-white text-4xl sm:text-5xl lg:text-6xl">
              Different Ways. One Goal.<br />
              <span className="text-white/40">Ultimate Business Success.</span>
            </h2>
          </FadeUp>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-white/5 border border-white/10">
          {SERVICES.map((svc, i) => (
            <motion.div
              key={svc.id}
              data-testid={`service-card-${svc.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 }}
              className="group relative bg-ink-900 p-10 md:p-14 overflow-hidden"
            >
              <span className="pointer-events-none absolute top-6 right-8 font-serif italic text-[120px] md:text-[140px] leading-none text-white/[0.06] group-hover:text-signal-500/25 transition-colors duration-700 select-none">
                {svc.n}
              </span>

              <div className="relative">
                <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-signal-500">
                  Practice / {svc.n}
                </span>
                <h3 className="display-heading mt-4 text-white text-3xl md:text-4xl">
                  {svc.title}
                </h3>
                <p className="mt-4 text-white/60 text-base md:text-lg leading-relaxed max-w-md">
                  {svc.caption}
                </p>

                <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1">
                  {svc.items.map((item, j) => (
                    <li
                      key={item}
                      className="group/item relative flex items-center gap-3 py-3 border-b border-white/8 last:border-b-0 sm:[&:nth-last-child(-n+2)]:border-b-0"
                    >
                      <span className="font-mono text-[10px] text-white/30 w-8">
                        {(j + 1).toString().padStart(2, '0')}
                      </span>
                      <span className="text-white/85 text-[15px] tracking-tight flex-1 transition-colors duration-300 group-hover/item:text-signal-500">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

        <FadeUp delay={0.2}>
          <p className="mt-10 md:mt-14 max-w-4xl text-white/70 text-xl md:text-2xl leading-relaxed">
            <span className="text-signal-500 mr-2">—</span>
            {SERVICES_CLOSING}
          </p>
        </FadeUp>
        <FadeUp delay={0.3}>
          <p className="mt-6 max-w-4xl text-white/70 text-xl md:text-2xl leading-relaxed">
            <span className="text-signal-500 mr-2">—</span>
            Onboard us as your Fractional CHRO or Virtual HR Department from Day One in your startup to build and scale a world-class culture.
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
